import type { Form, FormInputItem } from './content.ts';

export const formInputs = (form: Pick<Form, 'body'>): FormInputItem[] =>
  form.body.filter((item) => item.type !== 'Markdown');
